import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Switch (Single)
 *
 * @param props - checked, label, onChange, disabled
 * @example
 * <Switch
 * 	id=""
 * 	checked={false || true}
 * 	label="Switch"
 * 	onChange={() => {}}
 * 	disabled={false || true}
 * />
 * @returns React.ReactElement
 */
function Switch(props) {
    return _jsx(StyledComponent, __assign({}, props));
}
;
Switch.defaultProps = {};
var SampleProps = {
    id: '',
    checked: false,
    label: 'Switch',
    onChange: function () { },
    disabled: false,
};
export default Switch;
export { SampleProps as SwitchSample, };
